import { components } from "../../api/types";
import {
  getTwoDiagnosesCorrelatedMeasures,
  getQuantiles,
} from "../../api/calls";

type FilterParams = components["schemas"]["FilterParams"];
type Response = {
  diagnosesCorrelatedMeasures: number[];
  quantiles1: (components["schemas"]["Quantiles"] | null)[];
  quantiles2: (components["schemas"]["Quantiles"] | null)[];
};

/**
 * Bundled API calls for filtering between two populations.
 * 
 * @param filter1 Filter parameters for pop1
 * @param filter2 Filter parameters for pop2
 * @param signal Abort signal
 * @returns Correlated measures between two populations
 */
export const loadFilterTwoBundle = async (
  filter1: FilterParams,
  filter2: FilterParams,
  signal?: AbortSignal,
): Promise<Response> => {
  /* 1) set filters (only call what’s provided) */
  const [
    diagnosesCorrelatedMeasures,
    quantiles1,
    quantiles2,
  ] = await Promise.all([
    getTwoDiagnosesCorrelatedMeasures({filterParams1: filter1, filterParams2: filter2}, signal),
    getQuantiles({filterParams: filter1}, signal),
    getQuantiles({filterParams: filter2}, signal),
  ]);

  return {
    diagnosesCorrelatedMeasures,
    quantiles1,
    quantiles2,
  };
};
